export type StudyNavGroup = {
  id: string;
  /** Accordion header shown only when the group renders with more than one visible topic. */
  label?: string;
  topicIds: string[];
};

/**
 * Mirrors the collapsible groups in Components/Layout/StudySidebar.tsx (Participant
 * Management, Administration, Tracking, Add-ons) plus its standalone links, in the
 * same order. Each topic belongs to exactly one group. "study-settings" has no
 * siblings yet, so it renders as a flat item today — add more topics to its
 * topicIds and it becomes an accordion automatically, same as any other group.
 */
export const STUDY_NAV_GROUPS: StudyNavGroup[] = [
  { id: "dashboard", topicIds: ["study-dashboard"] },
  { id: "participants", label: "Participants", topicIds: ["participants", "participant-groups"] },
  { id: "study-designer", topicIds: ["study-designer"] },
  { id: "screening-reasons", topicIds: ["screening-reasons"] },
  { id: "appointments", topicIds: ["appointments"] },
  { id: "messages", topicIds: ["messages"] },
  {
    id: "administration",
    label: "Administration",
    topicIds: ["study-users", "site-rights", "study-rights"],
  },
  {
    id: "addons",
    label: "Add-ons",
    topicIds: ["cms-lms", "exercise", "econsent", "medication", "todo", "information-sheets"],
  },
  { id: "tracking", label: "Tracking", topicIds: ["consent-tracker", "audit-trail", "export"] },
  { id: "study-settings", topicIds: ["study-settings"] },
  { id: "queries", topicIds: ["queries"] },
];
